function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import App from 'modules/App';
export const MAX_DAYS_TO_SHOW_RELATED_DATA = 3;
export const BLOOD_GLUCOSE_PROFILE_AGP_CHART_COLORS = {
    PLACEHOLDER: '#E0E8F2',
    MEDIAN: '#2b4d8b',
    IQR: '#0094ff',
    P10P90: '#32bf00',
    RECORDS: '#6d6e71'
};
export const DAY_GLUCOSE_PROFILE_COLORS = _object_spread_props(_object_spread({}, App.constants.GLUCOSE_LEVELS_COLORS, App.constants.CHART_ELEMENTS_COLORS), {
    targetZone: App.constants.CHART_ELEMENTS_COLORS.placeholder,
    targetZoneBorder: App.constants.CHART_ELEMENTS_COLORS.placeholder
});
export const RELATED_DATA_CHART_OPTIONS = [
    'activities',
    'medications',
    'carbs',
    'weight',
    'height'
];
